var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcoArrowRightPlayerTitle = function SvgIcoArrowRightPlayerTitle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 10,
    fill: "none",
    viewBox: "0 0 8 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EEE",
    fillRule: "evenodd",
    d: "M5.086 4.508 5.05 4.46 1.436.23a.656.656 0 1 0-.998.852l3.37 3.946L.403 9.015a.656.656 0 0 0 .998.852l3.775-4.42a.656.656 0 0 0-.09-.939",
    clipRule: "evenodd"
  })));
};
export default SvgIcoArrowRightPlayerTitle;